import { render, staticRenderFns } from "./backPage.vue?vue&type=template&id=33cd3d7f&"
import script from "./backPage.vue?vue&type=script&lang=js&"
export * from "./backPage.vue?vue&type=script&lang=js&"
import style0 from "./backPage.vue?vue&type=style&index=0&id=33cd3d7f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports